import { useState, useEffect } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const BUILTIN_STATUSES = [
  { value: 'new',          label: 'New',          color: 'bg-blue-100 text-blue-700' },
  { value: 'assigned',     label: 'Assigned',     color: 'bg-indigo-100 text-indigo-700' },
  { value: 'contacted',    label: 'Contacted',    color: 'bg-yellow-100 text-yellow-700' },
  { value: 'qualified',    label: 'Qualified',    color: 'bg-purple-100 text-purple-700' },
  { value: 'closed_won',   label: 'Closed Won',   color: 'bg-green-100 text-green-700' },
  { value: 'closed_lost',  label: 'Closed Lost',  color: 'bg-red-100 text-red-700' },
];

export default function useLeadStatuses() {
  const [customStatuses, setCustomStatuses] = useState([]);

  useEffect(() => {
    axios.get(`${API}/lead-statuses`)
      .then(res => setCustomStatuses(res.data.custom || []))
      .catch(() => {});
  }, []);

  const allStatuses = [
    ...BUILTIN_STATUSES,
    ...customStatuses.map(label => ({
      value: label,
      label,
      color: 'bg-slate-100 text-slate-700',
    })),
  ];

  const addStatus = async (label) => {
    const trimmed = label.trim();
    if (!trimmed) return null;
    await axios.post(`${API}/lead-statuses`, { label: trimmed });
    setCustomStatuses(prev => [...prev, trimmed]);
    return trimmed;
  };

  return { allStatuses, addStatus };
}
